import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DividerComponent } from '@shared/components/divider.component';
import { TitleContainerComponent } from '@shared/components/title-container.component';
import { TreatyType, TreatyTypeEnum } from '../models/treaty.model';
import { NEW_TREATY_TEXTS } from './new-treaty-texts.data';
import { TreatyApiService } from '../services/treaty-api.service';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { downloadFileFromAssetFolder } from '@shared/utils/file.utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-treaty',
  imports: [
    TitleContainerComponent,
    DividerComponent,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './new-treaty.component.html',
  styleUrl: './new-treaty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewTreatyComponent {
  treatyTexts = NEW_TREATY_TEXTS;
  secondStep = signal<TreatyType | 'none'>('none');
  isLoadingSubmit = signal(false);

  treatyApiService = inject(TreatyApiService);
  router = inject(Router);

  portfolioControl = new FormControl('', { nonNullable: true });

  goToNextStep(type: TreatyType) {
    this.secondStep.set(type);
  }

  goBack() {
    this.secondStep.set('none');
  }

  dowloadTemplate(type: TreatyType) {
    const filename = type === TreatyTypeEnum.Casualty ? 'Casualty_template_v1.xlsx' : 'Property_template_v1.xlsx';
    const filePath = `assets/files/${filename}`;
    downloadFileFromAssetFolder(filePath, filename);
  }

  uploadExcel(event: Event, fileInput: HTMLInputElement, type: TreatyType) {
    this.isLoadingSubmit.set(true);
    const files = (event.target as HTMLInputElement)?.files;
    if (files && files.length >= 0) {
      this.treatyApiService
        .createTreaty$(files[0], type, this.portfolioControl.value)
        .pipe(
          tap(res => {
            this.router.navigate([`treaty-assessments/detail/${type}`, res.treatyId]);
          }),
          catchError(() => {
            // Edge browser issue: if the file is not valid, we reset the input
            fileInput.value = '';
            return EMPTY;
          }),
          finalize(() => {
            this.isLoadingSubmit.set(false);
            this.portfolioControl.reset();
          })
        )
        .subscribe();
    }
  }
}
